import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { useQuery } from 'react-query';
import { getUserById } from '../services/userApi';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import './CertificatePage.css';

const CertificatePage = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const certificateRef = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    if (isAuthenticated === false) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);

  const { data: userData } = useQuery(
    ['user', user?.sub],
    () => getUserById(user?.sub),
    {
      enabled: !!user?.sub,
      staleTime: 1000 * 60 * 5,
    }
  );

  const handleDownload = async () => {
    if (!certificateRef.current) return;
    setIsDownloading(true);
    try {
      const canvas = await html2canvas(certificateRef.current, {
        scale: 2, // Higher scale for better quality
        useCORS: true,
        logging: false,
        backgroundColor: '#fffaf0', // Match CSS background
        windowWidth: certificateRef.current.scrollWidth,
        windowHeight: certificateRef.current.scrollHeight
      });

      const imgData = canvas.toDataURL('image/png');
      // Create PDF with landscape orientation matching canvas dimensions
      const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'px',
        format: [canvas.width, canvas.height]
      });

      pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
      pdf.save('SaiSruti_Certificate.pdf');
    } catch (error) {
      console.error('Error generating certificate:', error);
      alert('Failed to generate certificate. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  };

  const studentName = userData?.fullName || user?.attributes?.name || 'Student';
  const completionDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="certificate-page-container">
      <div className="certificate-controls">
        <button onClick={() => navigate('/home')} className="btn-secondary">
          Back to Home
        </button>
        <button onClick={handleDownload} disabled={isDownloading} className="btn-primary">
          {isDownloading ? 'Generating PDF...' : 'Download Certificate'}
        </button>
      </div>

      <div className="certificate-preview-area">
        <div className="certificate-paper" ref={certificateRef}>
          <div className="certificate-border">
            <div className="certificate-content">
              <div className="certificate-header">
                <img src="/sruti-vaibhavam.png" alt="Sruti Vaibhavam" className="event-logo" crossOrigin="anonymous" />
                <h1 className="certificate-title">Certificate of Completion</h1>
                <p className="certificate-subtitle">This is to certify that</p>
              </div>

              <div className="certificate-name-section">
                <h2 className="student-name">{studentName}</h2>
                <div className="underline"></div>
              </div>

              <div className="certificate-body">
                <h2 className="exhibition-title">SRI SATHYA SAI SRUTI VAIBHAVAM</h2>
                <h3 className="exhibition-theme">JOURNEY FORWARD TO SAI ALONG WITH VEDIC PATH</h3>
              </div>

              <div className="certificate-footer">
                <div className="footer-item">
                  <span className="date-text">{completionDate}</span>
                  <div className="footer-line"></div>
                  <span className="footer-label">Date</span>
                </div>
                
                <div className="footer-org">
                   <p className="org-text">by Sri Sathya Sai Seva Organisations India</p>
                   <img src="/logo.png" alt="SSSSO India" className="org-logo" crossOrigin="anonymous" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificatePage;